var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOutlookCalendar = function SvgOutlookCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0072C6",
    d: "M19.484 7.938v5.477L21.4 14.62a.5.5 0 0 0 .21 0l8.238-5.554a1.174 1.174 0 0 0-.96-1.129z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0072C6",
    d: "m19.484 15.455 1.747 1.2a.52.52 0 0 0 .543 0c-.3.181 8.073-5.378 8.073-5.378v10.066a1.407 1.407 0 0 1-1.49 1.555h-8.874zM10.44 12.93a1.61 1.61 0 0 0-1.42.838 4.13 4.13 0 0 0-.526 2.218 4.05 4.05 0 0 0 .526 2.212 1.6 1.6 0 0 0 2.771.022 4 4 0 0 0 .515-2.2 4.37 4.37 0 0 0-.5-2.28 1.54 1.54 0 0 0-1.366-.81"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0072C6",
    d: "M2.153 5.155v21.427L18.453 30V2zM13.06 19.491a3.23 3.23 0 0 1-2.7 1.361 3.19 3.19 0 0 1-2.64-1.318A5.46 5.46 0 0 1 6.706 16.1a5.87 5.87 0 0 1 1.036-3.616 3.27 3.27 0 0 1 2.744-1.384 3.12 3.12 0 0 1 2.61 1.321 5.64 5.64 0 0 1 1 3.484 5.76 5.76 0 0 1-1.035 3.586"
  })));
};
export default SvgOutlookCalendar;